module.exports = __webpack_public_path__ + "img/icon-vkontacte.697e9ccb.svg";